<template>
	<el-dialog v-model="centerDialogVisible" title="" width="448" center align-center :show-close="false">
		<template #header="{ titleId }">
			<div class="my-header">
				<h4 :id="titleId" class="text-[20px] text-[#0D0421]">{{ props.title }}</h4>
			</div>
		</template>
		<div class="mt-2 mb-6 text-[18px] text-[#0D0421] text-center"> {{ props.msg }} </div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="large" class="cancel_btn" @click="centerDialogVisible = false">{{ $t('uChoicePc.cancel') }}</el-button>
				<el-button size="large" class="confirm_btn" type="primary" @click="onConfirm"> {{ $t('uChoicePc.determine') }} </el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
const props = defineProps({
	title: {
		type: String,
		default: ''
	},
	msg: {
		type: String,
		default: ''
	}
})
const emit = defineEmits(['confirm'])
const centerDialogVisible = ref(false)
const openDialog = () => {
	centerDialogVisible.value = true
}
const onConfirm = () => {
	centerDialogVisible.value = false
	emit('confirm')
}
defineExpose({ openDialog })
</script>
<style lang="scss" scoped>
.cancel_btn {
	border-radius: 16px;
	background: #f4f4f4;
	border: none;
	color: #0d0421;
	font-size: 18px;
	font-weight: normal;
	padding: 0 40px !important;
}
.confirm_btn {
	border-radius: 16px;
	background: #f92863;
	font-size: 18px;
	padding: 0 40px !important;
}
:deep(.el-dialog .el-dialog__footer .el-button) {
	padding: 0 40px !important;
}
</style>
